import classNames from 'classnames';
import orCardsListVariants from './or-cards-list.variants';
import { JSX } from 'react';

// components
import { MlCard } from '@/components/molecules/ml-card/ml-card';
import { AtHeader } from '@/components/atoms/at-header/at-header';
import { AtDivider } from '@/components/atoms/at-divider/at-divider';

// types
import {
  IOrCardsListProps,
  TOrCardsListSupportedLengths,
} from './or-card-list.types';
import {
  EDividerColors,
  EDividerDirectionalVariants,
  EDividerVariants,
} from '@/components/atoms/at-divider/at-divider.types';

/**
 * **OrCardsList** is a layout component that displays 2–4 cards in a responsive grid with optional heading, alignment, and decorative dividers.
 *
 * This component enforces a minimum of 2 and a maximum of 4 cards.
 * Layout behavior, spacing, and alignment are controlled via Tailwind Variants.
 */
export const OrCardsList = ({
  cards,
  alignment,
  heading,
  headingElement,
  topSpacing = 'md',
  bottomSpacing = 'md',
  topDivider = false,
  bottomDivider = false,
  wrapperClassName,
}: IOrCardsListProps): JSX.Element => {
  const { mainContainer, cardsContainer, header, base } = orCardsListVariants({
    totalCards: cards?.length as unknown as TOrCardsListSupportedLengths,
    alignment,
    topSpacing,
    bottomSpacing,
  });

  // if (cards.length < 2 || cards.length > 4) {
  //   return (
  //     <AtHeader>A minimum of two cards and a maximum of 4 is required</AtHeader>
  //   );
  // }

  return (
    <div data-theme="light">
      <section data-testid="or-cards-list" className="container">
        {topDivider && (
          <AtDivider
            decorative
            color={EDividerColors.GREY}
            direction={EDividerDirectionalVariants.HORIZONTAL}
            intent={EDividerVariants.THIN}
          />
        )}
        <div className={classNames(mainContainer(), base(), wrapperClassName)}>
          {heading && (
            <AtHeader
              element={headingElement || 'h2'}
              variant="h1"
              className={classNames(header())}
            >
              {heading}
            </AtHeader>
          )}
          <div
            data-testid="or-cards-list-container"
            className={classNames(cardsContainer())}
          >
            {cards.map((card, i) => (
              <MlCard {...card} key={`ml-card-list-${i}`} />
            ))}
          </div>
        </div>
        {bottomDivider && (
          <AtDivider
            decorative
            color={EDividerColors.GREY}
            direction={EDividerDirectionalVariants.HORIZONTAL}
            intent={EDividerVariants.THIN}
          />
        )}
      </section>
    </div>
  );
};
